export default {
  agenda: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/components/schedule/resources/props.js